import { LoginPageComponent } from './views/booking/login-page/login-page.component';
import { LoginComponent } from './views/auth/login/login.component';
import { PayModalComponent } from './views/booking/pay-modal/pay-modal.component';
import { UpdateAdditionalModalComponent } from './views/booking/update-additional-modal/update-additional-modal.component';
import { ExtendRentalTimeModalComponent } from './views/booking/extend-rental-time-modal/extend-rental-time-modal.component';
import { AddRemoveExtrasModalComponent } from './views/booking/add-remove-extras-modal/add-remove-extras-modal.component';
import { ModifyPickupModalComponent } from './views/booking/modify-pickup-modal/modify-pickup-modal.component';
import { ChangePasswordComponent } from './views/auth/change-password/change-password.component';
import { LayoutInnerComponent } from './views/shared/layout-inner/layout-inner.component';
import { MyNotificationsComponent } from './views/booking/my-notifications/my-notifications.component';
import { MyFavouritsComponent } from './views/booking/my-favourits/my-favourits.component';
import { EditMyProfileComponent } from './views/profile/edit-my-profile/edit-my-profile.component';
import { ConfirmationComponent } from './views/booking/confirmation/confirmation.component';
import { ViewBookingComponent } from './views/booking/view-booking/view-booking.component';
import { MyBookingsComponent } from './views/booking/my-bookings/my-bookings.component';

import { RegisterComponent } from './views/auth/register/register.component';
import { TopDealsComponent } from './views/home/top-deals/top-deals.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { DatepickerInputComponent } from './views/shared/datepicker-input/datepicker-input.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes,CanActivate } from '@angular/router';
import { ViewComponent } from './views/customer/view/view.component';
import { HeaderComponent } from './views/shared/header/header.component';
import { FooterComponent } from './views/shared/footer/footer.component';
import { LayoutComponent } from './views/shared/layout/layout.component';
import { BannerComponent } from './views/home/banner/banner.component';
import { HomePageComponent } from './views/home/home-page/home-page.component';
import { SearchLocationPageComponent } from './views/search-location/search-location-page/search-location-page.component';
import { MainComponent } from './views/search-location/Main/Main.component';
import { SearchVehiclePageComponent } from './views/search-location/search-vehicle-page/search-vehicle-page.component';
import {ResetPasswordComponent} from './views/auth/reset-password/reset-password.component'
import { EmailVerificationComponent } from './views/auth/email-verification/email-verification.component';
import { DeclinedComponent } from './views/booking/declined/declined.component';
import { FailedComponent } from './views/booking/failed/failed.component';

const routes: Routes = [
  { path: 'customer-view', component: ViewComponent },
  { path: 'Layout', component: LayoutComponent },
  { path: 'Footer', component: FooterComponent },
  { path: 'Header', component: HeaderComponent },
  { path: 'Banner', component: BannerComponent },
  { path: 'home', component: HomePageComponent },//canActivate: [AuthGuard]
  { path: 'Datepicker', component: DatepickerInputComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'searchByLocation', component: MainComponent },
  { path: 'searchByVehicle', component: SearchVehiclePageComponent },
  { path: 'My-Bookings', component: MyBookingsComponent,canActivate: [AuthGuard] },
  { path: 'view-booking', component: ViewBookingComponent },
  { path: 'ConfirmationComponent', component: ConfirmationComponent },
  { path: 'Edit-My-Profile', component: EditMyProfileComponent },
  { path: 'My-Favourits', component: MyFavouritsComponent },
  { path: 'My-Notifications', component: MyNotificationsComponent },
  //{ path: 'LayoutInner', component: LayoutInnerComponent},
  { path: 'update-booking-date', component: ModifyPickupModalComponent},
  { path: 'update-booking-extra', component: AddRemoveExtrasModalComponent},
  { path: 'extend-rental-time', component: ExtendRentalTimeModalComponent},
  { path: 'update-additional-driver', component: UpdateAdditionalModalComponent},
   {path: 'pay', component: PayModalComponent},
   { path: 'login-page', component: LoginPageComponent },
   { path: 'email-verification', component: EmailVerificationComponent },
   {path: 'DeclinedComponent', component: DeclinedComponent},
   {path: 'FailedComponent', component: FailedComponent}

];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
   declarations: [

  ]
})
export class AppRoutingModule { }
